import { TooltipProps } from 'primereact/tooltip';

export enum TooltipPosition {
  Top = 'top',
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
}

export enum TooltipEvent {
  Hover = 'hover',
  Focus = 'focus',
  Both = 'both',
}

export enum TooltipType {
  Info = 'info',
  Error = 'error',
  Success = 'success',
  Warning = 'warning',
  NoIcon = 'no-icon',
}

export interface ITooltip extends TooltipProps {
  /**
   * Type of the tooltip
   */
  type?: TooltipType;
}
